// visibleOffset: Sometimes the bottom of an element is just empty white space, so it's weird when that element's nav
// item is selected instead of the next item. visibleOffset makes each element effectively start `x` pixels before its
// actual start position, so it can be selected as topmost instead of the element preceding it
window.aboundScrollNav = ({linkEls, currentClass, defaultTarget = null, updateUrl = true, visibleOffset = 50}) => {
    const throttle = (ms, f) => {
        let lastCallStamp = null
        let lastResult = null

        return (...args) => {
            const now = (new Date()).getTime()

            // don't do anything
            if(lastCallStamp !== null && (now - lastCallStamp) < ms) return lastResult

            lastCallStamp = now
            lastResult = f.apply(null, args)

            return lastResult
        }
    }

    const getElByTarget = targetStr => document.getElementById(targetStr.replace('#', ''))

    const getLinkByTarget = (linkEls, targetStr) => linkEls.reduce((acc, linkEl) => linkEl.getAttribute('target') === targetStr ? linkEl : acc, null)

    const isVisible = el => {
        const rect = el.getBoundingClientRect()

        return(
            rect.bottom >= 0
            && rect.right >= 0
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
            && rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    const getLinkElByTopmostVisibleTarget = (linkEls, defaultTarget) => {
        const topmostEl = [...linkEls].reduce((acc, linkEl) => {
            const href = linkEl.getAttribute('href')
            const targetEl = getElByTarget(href)

            if(!targetEl) return acc
            if(!isVisible(targetEl)) return acc

            const rect = targetEl.getBoundingClientRect()

            // adjust the element's start position by its CSS scroll-margin-top and the visibleOffset
            const computedStyle = window.getComputedStyle(targetEl),
                scrollMarginTopValue = computedStyle.getPropertyValue('scroll-margin-top'),
                elTop = rect.top - parseFloat(scrollMarginTopValue) - visibleOffset;

            // return the last element with a negative elTop, i.e. it started above the viewport
            return acc.el === null || elTop <= 0
                ? { el: linkEl, elTop: elTop }
                : acc
        }, { el: null, elTop: 0 }).el

        return topmostEl === null && defaultTarget
            ? getLinkByTarget(linkEls, defaultTarget)
            : topmostEl
    }

    const updateLinks = () => {
        const currentLinkEl = getLinkElByTopmostVisibleTarget(linkEls)

        linkEls.forEach(el => el.classList.remove(currentClass))

        if(currentLinkEl) {
            const href = currentLinkEl.getAttribute('href')
            currentLinkEl.classList.add(currentClass)

            if(updateUrl && window.location.hash !== href) {
                history.replaceState(null, null, href)
            }
        }
        else if(updateUrl) {
            history.replaceState(null, null, window.location.pathname + window.location.search)
        }
    }

    window.addEventListener('scroll', throttle(100, updateLinks))

    // run once on initial load
    updateLinks()
}



// WEBPACK FOOTER //
// ./scroll-nav.js